import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment-timezone';

import {LocalizationService} from '../localization/localization.service';
import {isValid, timeAgo, timeLeft} from '../utils/date';

@Pipe({name: 'gpDate'})
export class DateLocalizationPipe implements PipeTransform {

  constructor(private localization: LocalizationService) {
  }

  transform(date: string, params: any = {}, triggerDateChange?: any): string {
    const dateFormat = params.format || this.localization.dateFormat;

    if (isValid(date)) {
      if (!params.timezone) {
        params.timezone = this.getDefaultLocalTimezone();
      }

      let result: string = '';
      if (params.timeAgo) {
        result = timeAgo(date);
      } else if (params.timeLeft) {
        result = timeLeft(date);
      } else if (params.withTime) {
        result = moment.utc(date).tz(params.timezone).format(dateFormat + ' HH:mm:ss');
      } else if (params.withHour) {
        result = moment.utc(date).tz(params.timezone).format(dateFormat + ' HH:mm');
      } else {
        result = moment.utc(date).tz(params.timezone).format(dateFormat);
      }
      return result;
    }

    return date;
  }

  private getDefaultLocalTimezone(): string {
    const localMoment = moment();
    localMoment.locale('en');
    const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone || moment.tz.guess();
    const tz = localMoment.tz(defaultTimezone.toString()).format('Z');
    const offset = parseInt(tz, 10);

    return offset < 0 ? ('Etc/GMT+' + -offset) : ('Etc/GMT' + -offset);
  }
}
